import HowItWorksComponent from "./HowItWorksComponent";

const HowItWorks = ({ id }: any) => {
  return <HowItWorksComponent id={id} />;
};

export default HowItWorks;
